import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { formatNumber } from "src/i18n/formatNumber";
import UserSettingsService from "src/services/userSettingsService";
import { useDispatch, useSelector } from "src/store";

import { updateSearchQuery } from "@dashboard/devices/store";
import { selectGroups } from "@dashboard/groups/store/selectors";
import { expandGroupIdsWithDescendants } from "@dashboard/groups/utils";
import ElasticService from "@services/elasticService";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { TextLink } from "@shared/TextLink";

const ensureSystemVersionColumnVisible = () => {
    const currentVisibleColumns = UserSettingsService.getDevicePageVisibleColumns();

    const updatedVisibleColumns = {
        ...currentVisibleColumns,
        systemVersion: true,
    };
    UserSettingsService.setWorkspaceValue("devicePage.visibleColumns", updatedVisibleColumns);
};

interface TableItemProps {
    count: number;
    version: string;
    selectedGroupIds: number[];
}

const TableItem = ({ count, version, selectedGroupIds }: TableItemProps) => {
    const { t, i18n } = useTranslation(["common"]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const allGroups = useSelector(selectGroups);

    const handleOnClick = (selectedVersion: string) => {
        const filters = [
            { id: "systemVersion", value: [selectedVersion] },
            { id: "licenseStatus", value: ["Used"] },
        ];

        if (selectedGroupIds.length !== 0 && selectedGroupIds.length !== allGroups.length) {
            const expandedGroupIds = expandGroupIdsWithDescendants(selectedGroupIds, allGroups);
            filters.push({ id: "groupName", value: expandedGroupIds.map((id) => id.toString()) });
        }

        UserSettingsService.setWorkspaceValue("devicePage.columnFilters", filters);
        ensureSystemVersionColumnVisible();
        dispatch(updateSearchQuery(""));
        void navigate("/dashboard/devices");
        ElasticService.createTransaction("overviewPageLinkClick", {
            tab: "os-versions",
            text: count,
        });
    };

    return (
        <MinimalTableCell align="right">
            <TextLink onClick={() => handleOnClick(version)} tooltip={t("common:tooltip.showDevices", { count })}>
                {formatNumber(count, i18n.language)}
            </TextLink>
        </MinimalTableCell>
    );
};

export default TableItem;
